import { NODE_ENV } from 'constant/env';

export const isProduction = NODE_ENV === 'production';
export const isDev = NODE_ENV === 'development';
